export default {
  zh: {
    affiliateProgram: 'Plex加速器联盟推广计划',
    memberInfo: '加入我们成为 Plex加速器的联盟推广成员，获取高额佣金奖励。'
  },
  en: {
    affiliateProgram: 'PlexVPN Affiliate Program',
    memberInfo: 'Become a PlexVPN affiliate and start to earn money by promoting the higher speed, ultra secure and easy-to-use VPN.'
  }
}



// WEBPACK FOOTER //
// ./src/components/affiliateProgram/banner/lang.js